import api, { tokenManager } from './api'

export interface User {
  id: number
  email: string
  firstName: string
  lastName: string
  role: string
  employee?: {
    id: number
    employeeNumber: string
    department: string
    position: string
  }
}

export interface LoginCredentials {
  email: string
  password: string
}

export interface AuthResponse {
  user: User
  tokens: {
    accessToken: string
    refreshToken: string
  }
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post('/auth/login', credentials)
    const { user, tokens } = response.data.data
    
    // Store tokens
    tokenManager.setTokens(tokens.accessToken, tokens.refreshToken)
    
    return { user, tokens }
  },

  async getProfile(): Promise<User> {
    const response = await api.get('/auth/profile')
    return response.data.data.user
  },

  async changePassword(data: {
    currentPassword: string
    newPassword: string
    confirmPassword: string
  }): Promise<void> {
    await api.post('/auth/change-password', data)
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout')
    } catch (error) {
      // Continue with logout even if API call fails
      console.error('Logout API call failed:', error)
    } finally {
      tokenManager.clearTokens()
    }
  },

  isAuthenticated(): boolean {
    return !!tokenManager.getAccessToken()
  }
}

export default authService